import { useTranslation } from '@utils/i18n/i18n';

function EbroDeltaChallengesAndSolutions() {
  const { t } = useTranslation();

  return (
    <>
      <p>
        {t('The Ebro Delta is a highly dynamic wetland and coastal system where agriculture, aquaculture, tourism, conservation and protected-area management interact, creating strong relevance for eutrophication risk, biodiversity monitoring and ecosystem-health assessment.')}
      </p>
      <p>
        {t('ENHANCE aims to address agricultural pressure, eutrophication risk, protected-area relevance, biodiversity observation and ecosystem-health monitoring in the Ebro delta area.')}
      </p>
      <div>
        {t('This will be realized by looking at the following data streams:')}
        <ul>
          <li>{t('Copernicus Earth Observations products to support chlorophyll-a/eutrophication products supported by land cover data')}</li>
          <li>{t('citizen-science data collected through MINKA focussing on coastal plant occurences and biodiversity-related observations')}</li>
          <li>{t('AI-assisted validation and data-quality workflows for coastal plant observations')}</li>
        </ul>
      </div>
    </>
  );
}

function BarcelonaChallengesAndSolutions() {
  const { t } = useTranslation();

  return (
    <>
      <p>
        {t('The Barcelona Metropolitan Area is characterized by the following challenges: intense recreational use, urban runoff, tourism pressure, wastewater-overflow and strong public interest in bathing-water quality and biodiversity.')}
      </p>
      <p>
        {t('In Barcelona, the ENHANCE project aims to address urban and recreational pressures, bathing-water relevance, biodiversity monitoring and anthropogenic impacts on coastal ecosystems.')}
      </p>
      <div>
        {t('This will be realized by looking at the following data streams:')}
        <ul>
          <li>{t('Copernicus Earth Observations products to support turbidity-based early-warning layers and chlorophyll-a/eutrophication products supported by land cover data')}</li>
          <li>{t('citizen-science data collected through MINKA focussing on fish observations, species richness and alien-species information')}</li>
          <li>{t('AI-assisted validation and data-quality workflows for fish observations')}</li>
        </ul>
      </div>
    </>
  );
}

const LOCATIONS = [
  {
    id: 'barcelona',
    label: 'Barcelona',
    coordinates: [2.177782919700881, 41.382435878878688],
    aboutParagraphs: [
      'The Barcelona Metropolitan Area is home to some of the most heavily visited urban beaches in Catalonia, with more than 10 million visitors annually.',
      'The Barcelona urban beaches face significant environmental pressures, including eutrophication due to urbanization and storm-induced erosion.',
    ],
    challengesTitle: 'Challenges & solutions in Barcelona',
    challengesText: <BarcelonaChallengesAndSolutions />,
    imageAlt: 'Barcelona challenges and solutions',
    imagePath: '/img/misc/barcelona.png',
  },
  {
    id: 'ebro-delta',
    label: 'Ebro delta',
    coordinates: [0.794797874047871, 40.7049514918737],
    aboutParagraphs: [
      'The Ebro Delta, known for its agricultural activities and extensive aquaculture, faces challenges from freshwater inflows, agricultural runoff, and mussel farming.',
      'These areas are critical to local biodiversity, tourism, and coastal health, requiring improved monitoring and management.',
    ],
    challengesTitle: 'Challenges & solutions in the Ebro delta',
    challengesText: <EbroDeltaChallengesAndSolutions />,
    imageAlt: 'Ebro delta challenges and solutions',
    imagePath: '/img/misc/ebro-delta.png',
  },
];

export { LOCATIONS };
